module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin leer 1.e8634d79.svg";